/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Rejected_LabelInputs */

const en_samples_rejected_label = /** @type {(inputs: Samples_Rejected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const es_samples_rejected_label = /** @type {(inputs: Samples_Rejected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazada(s)`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Samples_Rejected_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_rejected_label = /** @type {((inputs?: Samples_Rejected_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Rejected_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_rejected_label(inputs)
	return es_samples_rejected_label(inputs)
});